import React from 'react';
import { connect } from 'react-redux';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';
import ServiceCard from './card';
import NoSSR from '~/src/helpers/noSSR';
import { BackgroundImage, Card, CardContainer, Container, Header, SubHeader } from './styled';
import Form from './form/index';
import Plank from './plank/index';
import { declOfNum } from '@ertelecom/ui-react/components/helpers';
import { requestIntercomServices } from '~/src/api/shop';

const serviceText = declOfNum(['сервиса', 'сервиса', 'сервисов']);

class OnlineServices extends React.Component {
  state = {
    services: [],
  }

  componentDidMount() {
    this.getIntercomServices();
  }

  componentDidUpdate(prevProps) {
    if ((prevProps.isAuth !== this.props.isAuth) && this.props.isAuth) {
      this.getIntercomServices();
    }
  }

  getIntercomServices = () => {
    requestIntercomServices(this.props.city.domain, this.props.authToken)
      .then(response => {
        this.setState({ services: response.data.items });
      })
      .catch(err => console.log(err));
  }

  checkServicesExist = () => {
    const { services } = this.state;
    const filtered = services.filter(item => item.exists == true);
    switch (filtered.length) {
      case 0:
        return null;
      case 1:
        return <Plank connected={filtered[0].title}/>;
      default:
        return <Plank connected={filtered.length + ' ' + serviceText(filtered.length)}/>;
    }
  }

  renderCard = (card, index) => {
    return <Card>
      <ServiceCard
        key={index}
        orderId={card.id}
        domain={this.props.city}
        description={card.body}
        name={card.title}
        price={card.prices.possess}
        buttonText={card.button_text}
        image={card.image}
        type={card.category.title}
        data={card.prices.rent}
        pricesPromo={card.pricesPromo}
        priceTextBoolean={true}
        orderByCall={card.category.buy_by_call}
        exist={card.exists}
        buttonLink={card.button_link}
        buttonTextExists={card.category.button_text_exists}
      />
    </Card>;
  }

  render() {
    const { services } = this.state;
    return (
      <Container>
        <GridContainer>
          <Header>Добавить к домофону</Header>
          {services &&
          <NoSSR>
            <React.Fragment>
              {services.length > 0 ? <>
                {this.checkServicesExist()}
                <CardContainer>
                  {services.map((lot, index) => this.renderCard(lot, index))}
                </CardContainer></>
                : <>
                  {this.checkServicesExist()}
                  <CardContainer>
                    <SubHeader>Сейчас у вас нет услуг и оборудования для подключения</SubHeader>
                  </CardContainer>
                </>
              }
            </React.Fragment>
          </NoSSR>}
        </GridContainer>
        <GridContainer>
          <Form/>
        </GridContainer>
        <BackgroundImage viewBox='0 0 1717 1434' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M1717 1434V472V0L0.5 1434H1717Z' fill='#F7F7F8'/>
          <path d='M1717 1434V472L551 1434H1717Z' fill='#EBEBEB'/>
          <path d='M1717 1434V492L571 1434H1717Z' fill='#FFFFFF'/>
        </BackgroundImage>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  city: state.city.currentCity,
  billingDomain: state.auth.billingDomain,
  isAuth: state.auth.isAuth,
  authToken: state.auth.accessToken
});

export default connect(mapStateToProps)(OnlineServices);
